import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUserLoginData } from "../../api/ekoApi";

const CreateAdminForm = ({ handleSubmit, handleCloseModal }) => {
  const { t } = useTranslation();
  const { control, handleSubmit: rhfHandleSubmit } = useForm();
  const { data: loggedUser } = useUserLoginData();

  const isDisabled = loggedUser?.role !== "SuperAdmin";
  const handleCreateClick = (data) => {
    handleSubmit(data);
    handleCloseModal();
  };

  const handleCancelClick = () => {
    handleCloseModal();
  };

  return (
    <form onSubmit={rhfHandleSubmit(handleCreateClick)}>
      <Controller
        name="email"
        control={control}
        rules={{
          required: "Please enter email",
        }}
        render={({ field, fieldState }) => (
          <TextField
            label={t("email")}
            type="email"
            {...field}
            sx={{ width: "100%", marginTop: "10px" }}
            error={fieldState?.invalid}
          />
        )}
      />
      <Controller
        name="password"
        control={control}
        rules={{
          required: "Please enter password",
        }}
        render={({ field, fieldState }) => (
          <TextField
            label="Password"
            type="password"
            {...field}
            sx={{ width: "100%", marginTop: "10px" }}
            error={fieldState?.invalid}
          />
        )}
      />
      <Controller
        name="displayName"
        control={control}
        rules={{
          required: "Please enter display name",
        }}
        render={({ field, fieldState }) => (
          <TextField
            label={t("displayName")}
            {...field}
            sx={{ width: "100%", marginTop: "10px" }}
            error={fieldState?.invalid}
          />
        )}
      />
      <Controller
        name="organization"
        control={control}
        defaultValue={
          loggedUser?.role === "SuperAdmin" ? "" : loggedUser?.organization // Provide a fallback value
        }
        rules={{
          required: "Please enter organization",
        }}
        render={({ field, fieldState }) => (
          <TextField
            disabled={isDisabled}
            label={t("organization")}
            {...field}
            error={fieldState?.invalid}
            sx={{ width: "100%", marginTop: "10px" }}
          />
        )}
      />
      {loggedUser?.role === "Admin" && (
        <Controller
          name="subOrganization"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              //disabled={isDisabled}
              label={t("suborganization")}
              {...field}
              error={fieldState?.invalid}
              sx={{ width: "100%", marginTop: "10px" }}
            />
          )}
        />
      )}
      {loggedUser?.role === "Admin" && (
        <Controller
          name="town"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              //disabled={isDisabled}
              label={t("town")}
              {...field}
              error={fieldState?.invalid}
              sx={{ width: "100%", marginTop: "10px" }}
            />
          )}
        />
      )}
      <Controller
        name="role"
        control={control}
        defaultValue={loggedUser?.role === "SuperAdmin" ? "" : "User"}
        rules={{
          required: "Please select Role",
        }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth sx={{ marginTop: "10px" }}>
            <InputLabel id="role-label">{t("role")}</InputLabel>
            <Select
              sx={{ width: "100%", marginTop: "10px" }}
              labelId="role-label"
              {...field}
              disabled={isDisabled}
              error={fieldState?.invalid}
            >
              {loggedUser?.role === "SuperAdmin" && (
                <MenuItem value="Admin">Admin</MenuItem>
              )}
              <MenuItem value="User">{t("user")}</MenuItem>
            </Select>
          </FormControl>
        )}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button
          type="button"
          onClick={handleCancelClick}
          sx={{ marginLeft: "10px" }}
        >
          {t("cancel")}
        </Button>
        <Button type="submit" sx={{ marginLeft: "10px" }}>
          {t("create")}
        </Button>
      </Box>
    </form>
  );
};

export { CreateAdminForm };
